import * as urlUtils from 'utils/Url';


export function getPathPartnerOverview(qs={}) {
  return urlUtils.appendQueryString(`/partner-overview`, qs);
}

export function getPathEditPartner() {
  return `/partners/edit`;
}

export function getPathPartnerMetrics(qs={}) {
  return urlUtils.appendQueryString(`/partner-metrics`, qs);
}

export function getPathPartnerCommissions(qs={}) {
  return urlUtils.appendQueryString(`/partner-commissions`, qs);
}

export function getPathPartnerPayouts(qs={}) {
  return urlUtils.appendQueryString(`/partner-payouts`, qs);
}

//======================================
// Agencies
//======================================
export function getPathAgency() {
  return `/agency`;
}

export function getPathAddAgency() {
  return `/agency/add`;
}

export function getPathEditAgency() {
  return `/agency/edit`;
}


//======================================
// Partner Deal
//======================================
export function getPathPartnerDeals(qs={}) {
  return urlUtils.appendQueryString(`/partner-deals`, qs);
}

export function getPathPartnerDealRedemption(dealId) {
  return `/partner-deals/${dealId}/redemption`;
}
